




















































































































































import { Component, Vue } from 'vue-property-decorator';
import PersonnelTable from '@/components/PersonnelTable.vue';
import PersonnelStateSelector from '@/components/PersonnelStateSelector.vue';
import Objective from '@/components/Objective.vue';

import { mapState } from 'vuex';

@Component({
  components: {
    PersonnelTable,
    PersonnelStateSelector,
    Objective
  },
  data() {
    return {
      customPopulation: null,
      showShiftsPerDayInput: false,
      showShiftHoursInput: false,
      showVaxPerHourInput: false,
      showCampaignDurationInput: false
    }
  },
  computed: {
        ...mapState(['selectedState','vaccinationGoal','targetPercent','personnelOption','personnelNation','personnelCounties','shiftHours','vaxPerHour','shiftsPerDay','campaignDuration','totalVaxPerDay'])
    },
  methods: {
        selectState(event) {
          this.$store.dispatch('selectState', event.target.value);
        },
        selectVaxGoal(event) {
          this.$store.dispatch('selectVaxGoal', event.target.value);
        },
        customAssumption(value, target) {
          if (value === '0' || value === '' || value === null) {
            alert("Please enter a number greater than zero.")
          }
  else {
    let clinics = (value * target) / 24000;
  clinics = Math.ceil(clinics);
  const workers = clinics * 170 * 2;
  const obj = {
    jurisdiction: "Custom",
    population: value,
    clinics: clinics,
    workers: workers
  };
  this.$store.dispatch('addCustomPersonnel', obj);
  }
},
selectPersonnelOption(event) {
    this.$store.dispatch('selectPersonnelOption', event.target.value);
},
setShiftsPerDay(event) {
  console.log(event.target.value);
  if (event.target.value === '0' || event.target.value === "") {
    alert("Please enter a number greater than zero.")
  }
  else {
    this.$store.dispatch('setShiftsPerDay', event.target.value);
  }
},
setCampaignDuration(event) {
  if (event.target.value === '0' || event.target.value === "") {
    alert("Please enter a number greater than zero.")
  }
  else {
    this.$store.dispatch('setCampaignDuration', event.target.value);
  }
},
setVaxPerHour(event) {
  if (event.target.value === '0' || event.target.value === "") {
    alert("Please enter a number greater than zero.")
  }
  else {
    this.$store.dispatch('setVaxPerHour', event.target.value);
  }
},
setShiftHours(event) {
  if (event.target.value === '0' || event.target.value === '') {
    
    alert("Please enter a number greater than zero.")
  }
  else {
    this.$store.dispatch('setShiftHours', event.target.value);
  }
},
resetPersonnelValues() {
  this.$store.dispatch('resetPersonnelValues');
},
resetPersonnelCustom() {
  this.$store.dispatch('resetPersonnelCustom');
}
  },
  created() {
    this.$store.dispatch("setRoute", "personnel");
    if (this.$route.params.option === 'nation') {
      this.$store.dispatch('selectPersonnelOption', 'nation');
    }
    else if (this.$route.params.option === 'county') {
      this.$store.dispatch('selectPersonnelOption', 'county');
    }
  },
  mounted() {
    this.$store.dispatch('drawPersonnel');
    this.$store.dispatch("setHref", this.$router.currentRoute.path);
  }
})
export default class Home extends Vue {
  
}
